module.exports = __webpack_public_path__ + "static_pest_wiki_details/img/iconzhengpin.8487327.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/iconzhengpin.svg
// module id = EAL5
// module chunks = 0